var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (undefined) {
buf.push("<div ng-cloak=\"ng-cloak\" class=\"detailForm\"><detail-header></detail-header><div layout=\"row\" flex=\"flex\" class=\"detailContent\"><div flex=\"flex\" layout=\"column\" class=\"detailLeftPanel\"><div layout-fill=\"layout-fill\" class=\"detailLeftPanelContainer\"><div layout-padding=\"layout-padding\" class=\"detailTopPanel\">" + (null == (jade_interp = require("/home/runner/work/banquetNinja/banquetNinja/app/features/production/units/tabs/top-panel.jade").call(this, locals)) ? "" : jade_interp) + "</div></div></div></div><detail-footer></detail-footer></div>");}.call(this,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/production/units/unit-detail.jade
// module id = 224
// module chunks = 0